import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import "./ActionsMenu.css";

interface ActionsMenuProps {
    menuItems: MenuItem[];
    secondary?: boolean;
    large?: boolean;
}

export const ActionsMenu = (props: ActionsMenuProps) => {
    const { t } = useTranslation("common");

    const exportMenu = useRef<any>(null);

    const onClick = (e: any) => {
        exportMenu.current.toggle(e);
    };

    const buttonClass = () => {
        let classes = "";
        if (props.secondary) {
            classes += " menu-button-secondary";
        }

        if (props.large) {
            classes += " menu-button-large";
        }

        return classes;
    };

    return (
        <div
            className="menu-btn"
            onMouseLeave={(e) => {
                exportMenu.current.hide(e);
            }}
        >
            <Button
                size={props.large ? undefined : "small"}
                className={buttonClass()}
                icon="pi pi-chevron-down"
                iconPos="right"
                onClick={(e) => onClick(e)}
                label={t("actionsMenu.label")}
                data-cy="menuButton-actions"
                data-testid={"menu-button"}
            >
                <Menu
                    className="w-full md:w-15rem"
                    ref={exportMenu}
                    popup
                    model={props.menuItems}
                />
            </Button>
        </div>
    );
};
